module.exports = __webpack_public_path__ + "media/images/talent/mv-slider06-44c2268b3b7e3c6eefe3f6e91c82b8e4.png";